module.exports = __webpack_public_path__ + "img/christian_breitung.d8e3fdf3.jpg";